import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard, SiteFooterLayout, SiteHeaderProvider, SliceLayoutBoundary } from '@shapeable/ui';
import { BannerTitles } from '../entities/banner-titles';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`

    /* override title styles via BEM here to affect spacing */ 
    .shp--page-layout-standard__title {
      width: 100%;
      font-weight: 600;
    }
  `,
  tablet: css`
    .shp--banner-titles {
      width: 100%;
    }
  `,
  desktop: css`
  `
});


const FooterStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
    Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const PageLayoutHome: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  return (
    <SiteHeaderProvider value={{
      variant: 'default',
      
    }}>
    <My.Layout 
      entity={entity}
      slices={slices}
      bannerTitles={<BannerTitles entity={entity} />}
      headerProps={{ 
        showOverlayGradient: true, 
        variant: 'overlay', 
        backgroundColor: '#000000',
        fadeColor: '#0000000', 
       }}
      className={className}
    >
    </My.Layout>
    <My.Footer />
    </SiteHeaderProvider>
  )
};
